import { Map } from 'immutable';
import { specialtiesListActions } from './actions';
import { createSpecialtiesList } from './specialties-list';

export const initialState = new Map({
  currentSpecialtiesListId: null
});

export const specialtiesListReducer = (state =  initialState  , {payload, type} ) => {

  switch (type) {
    case specialtiesListActions.FETCH_SPECIALTIES_SUCCESS:    
      return state.withMutations(specialtiesList => {
        if (!specialtiesList.has(payload.id) ) {
          specialtiesList.set(payload.id, createSpecialtiesList(payload));
        }
      });
    case specialtiesListActions.LOAD_SPECIALTIES:
      return state.set('currentSpecialtiesListId', payload.id);
    default:
      return state;
  }
}
